module.exports = __webpack_public_path__ + "img/right.f435d4e7.png";